import utils, { UTILS } from '../../utils'

var LABEL_DATA_MANAGER = {
    /**
     * 根据服务器返回数据获取前端所需数据
     * @param {服务器返回数据} data 
     */
    getMyLabelDataListByData(data) {
        var resultData = [];
        data.forEach(element => {
            var newData = Object.assign({
                type: 'my',
                choosed: false
            }, element);
            resultData.push(newData);
        })
        console.log('getMyLabelDataListByData-----', resultData)
        return resultData;
    },
    /**
     * 根据服务器返回数据获取前端所需数据
     * @param {服务器返回数据} data 
     */
    getMyLabelDataByData(data) {
        var newData = Object.assign({
            type: 'my',
            choosed: true
        }, data);
        return newData;
    },
    /**
     * 根据params来更新自定义标签数据
     * @param {原始数据} origiList 
     * @param {修改的参数} params 
     */
    updateMyLabelDataByParams(origiList, params) {
        origiList.forEach((element, index) => {
            if(element.id == params.id) {
                origiList[index].f_title = params.newTitle;
            }
        })
        return origiList;
    },
    /**
     * 根据id来删除自定义标签数据
     * @param {原始数据} origiList 
     * @param {删除的数据id} id 
     */
    deleteMyLabelDataById(origiList, id) {
        origiList.forEach((element, index) =>  {
            if(element.id == id) {
                origiList.splice(index, 1);
            }
        })
        return origiList;
    },
    /**
     * 根据服务器返回数据获取前端所需数据
     * @param {服务器返回数据} data 
     */
    getCommonLabelDataListByData(data) {
        var resultData = {}, resultList = [];
        for(var keys in data) {
            var newList = [];
            data[keys].forEach(element => {
                var newData = Object.assign({
                    type: 'common',
                    choosed: false
                }, element)
                newList.push(newData);
                resultList.push(newData);
            });
            resultData[keys] = newList;
        }
        console.log('getCommonLabelDataListByData-------', resultData)
        return {
            data: resultData,
            list: resultList
        };
    },
    /**
     * 点击的时候刷新选中的状态数据
     * @param {原始数据} origiList 
     * @param {修改的数据} data 
     */
    updateMyLabelDataChoosedStatus(origiList, data) {
        origiList.forEach((element, index) => {
            if(element.id == data.id) {
                origiList[index].choosed = !data.choosed;
            }
        });
        return origiList;
    },
    /**
     * 设置选中的状态数据
     * @param {原始数据} origiList 
     * @param {修改的数据} data 
     * @param {修改的状态} status 
     */
    setMyLabelDataChoosedStatus(origiList, data, status) {
        origiList.forEach((element, index) => {
            if(element.id == data.id) {
                origiList[index].choosed = status;
            }
        });
        return origiList;
    },
    /**
     * 点击的时候刷新选中的状态数据
     * @param {原始数据} origiData 
     * @param {修改的数据} data 
     */
    updateCommonLabelDataChoosedStatus(origiData, data) {
        var keys = data.f_category;
        if(!origiData[keys]) { return; }
        origiData[keys].forEach((element, index) => {
            if(element.id == data.id){
                origiData[keys][index].choosed = !data.choosed;
            }
        });
        return origiData[keys];
    },
    /**
     * 设置选中的状态数据
     * @param {原始数据} origiData 
     * @param {修改的数据} data 
     * @param {修改的状态} status 
     */
    setCommonLabelDataChoosedStatus(origiData, data, status) {
        var keys = data.f_category;
        if(!origiData[keys]) { return; }
        origiData[keys].forEach((element, index) => {
            if(element.id == data.id){
                origiData[keys][index].choosed = status;
            }
        });
        return origiData[keys];
    },
    /**
     * 重置我的自定义标签的选中状态
     * @param {原始数据} origiList 
     */
    resetMyLabelDataChoosedStatus(origiList) {
        origiList.forEach((element, index) => {
            origiList[index].choosed = false;
        })
        return origiList;
    },
    /**
     * 重置常用标签的选中状态
     * @param {原始数据} origiData 
     */
    resetCommonLabelDataChoosedStatus(origiData) {
        for(var keys in origiData) {
            origiData[keys].forEach((element, index) => {
                origiData[keys][index].choosed = false;
            });
        }
        return origiData;
    },
    /**
     * 根据选中的数据获取八字的label参数
     * @param {原始数据} origiList 
     */
    getSelectedLabelParamsByList(origiList) {
        var totalStr = '', resultStr = '', resultId = '';
        origiList.forEach((element, index) => {
            if(index == 0) {
                resultStr = resultStr + element.f_title;
            }
            totalStr = totalStr == '' ? (totalStr + element.f_title) : (totalStr + ',' + element.f_title);
            resultId = resultId == '' ? (resultId + element.id) : (resultId + ',' + element.id);
        })
        console.log('getSelectedLabelParamsByList------', resultStr, resultId)
        return {
            totalStr: totalStr,
            string: resultStr,
            id: resultId
        };
    },
    /**
     * 检查数据id是否在选中列表中
     * @param {选中列表数据} origiList 
     * @param {检查数据id} id 
     */
    checkSelectedLabelDataStatus(origiList, id) {
        for(var i = 0; i < origiList.length; i++) {
            if(origiList[i].id == id) {
                return true;
            }
        }
        return false;
    },
    /**
     * 
     * @param {选中列表数据} origiList 
     * @param {新增数据返回} newData 
     */
    updateSelectedLabelDataByData(origiList, newData) {
        console.log('updateSelectedLabelDataByData-----111111-----', origiList)
        origiList.forEach((element, index) => {
            if(element.id.toString().indexOf('new') != -1 && element.f_title == newData.f_title) {
                origiList[index].id = newData.id;
                origiList[index].type = 'my';
            }
        })
        console.log('updateSelectedLabelDataByData-----', origiList)
        return origiList;
    },
    /**
     * 根据当前数据信息删除列表中的这项数据
     * @param {原始数据列表} origiList 
     * @param {删除的数据} data 
     */
    deleteSelectedDataByData(origiList, data) {
        origiList.forEach((element, index) => {
            if(element.id == data.id) {
                if(origiList.length == 1) {
                    origiList.splice(0)
                } else {
                    origiList.splice(index, 1);
                }
            }
        })
        return origiList;
    },
    /**
     * 检查选中标签或者输入标签是否有重复的
     * @param {选中列表数据} origiList 
     * @param {输入文字} inputValue 
     */
    checkUnduplicatedSelectedLabelData(origiList, inputValue) {
        var returnDuplicated = false;
        origiList.forEach(element => {
            if(element.f_title == inputValue) {
                returnDuplicated = true;
            }
        })
        return returnDuplicated;
    },
    /**
     * 
     * @param {全部标签数据} origiList 
     * @param {标签的ID} labelId 
     */
    getConfirmLabelDataByLabelId(origiList, labelId) {
        if(!labelId) { return []; }
        var labelArr = labelId.split(','), resultList = [];
        origiList.forEach(element => {
            labelArr.forEach(id => {
                if(element.id == id) {
                    resultList.push(element);
                }
            })
        })
        console.log('getConfirmLabelDataByLabelId-------', resultList);
        return resultList;
    },
    /**
     * 根据文字获取全部数据里的标签数据
     * @param {全部数据} origiList 
     * @param {标签文字} labelText 
     */
    getLabelInTotalLabelListByText(origiList, labelText) {
        var resultLabel = {};
        origiList.forEach(element => {
            if(element.f_title == labelText) {
                resultLabel = element;
            }
        });
        return resultLabel;
    },
    /**
     * 根据选中的标签获取搜索页标签文本
     * @param {全部数据} origiList 
     */
    getSearchedLabelStringByList(origiList) {
        var resultString = '';
        origiList.forEach(element => {
            resultString += (element.f_title + '、');
        })
        if(resultString.length >= 10) {
            if(resultString.charAt(9) == '、') {
                resultString = resultString.slice(0, 9) + '等';
            }else {
                resultString = resultString.slice(0, 10) + '等';
            }
        }else {
            resultString = resultString.slice(0, -1);
        }
        return resultString;
    }
}

export {
    LABEL_DATA_MANAGER
}